// @flow

import React, {Fragment} from 'react';
import StarRating from '@homeaway/react-star-rating';
import gql from 'graphql-tag';
import './Rating.less';
import {FormattedMessage} from 'react-intl';

export const fragments = {
    listing: gql`
        fragment RatingListing on Listing {
            averageRating
            reviewCount
        }
    `
};
export type ListingShape = {
    averageRating: number,
    reviewCount: number
};
export type Props = {
    listing: ListingShape
};

const Rating = ({listing: {averageRating, reviewCount}}: Props) => {
    if (reviewCount === 0) {
        return (
            <span className="sr-only">
                <FormattedMessage id="noReviews" defaultMessage="no reviews" />
            </span>
        );
    }

    return (
        <Fragment>
            <span className={'Rating__starRating'} aria-hidden="true">
                <StarRating rating={averageRating} />
            </span>
            {` (${reviewCount})`}
            <span className="sr-only">
                <FormattedMessage
                    id="averageRatingSort"
                    defaultMessage="rating"
                >
                    {(txt) => (
                        <Fragment>
                            {txt}
                            {':'} {averageRating}
                        </Fragment>
                    )}
                </FormattedMessage>

                <FormattedMessage
                    id="reviewsSort"
                    defaultMessage="number of reviews"
                >
                    {(txt) => (
                        <Fragment>
                            {txt}
                            {':'} {reviewCount}
                        </Fragment>
                    )}
                </FormattedMessage>
            </span>
        </Fragment>
    );
};

export default Rating;
